import React from "react";
import { Tag } from "antd";

interface WaterTypeBadgeProps {
  isHot?: boolean | null;
}

export const WaterTypeBadge: React.FC<WaterTypeBadgeProps> = ({ isHot }) => {
  if (isHot === null || isHot === undefined) {
    return <Tag color="default">Unknown</Tag>;
  }
  return isHot ? <Tag color="volcano">Hot</Tag> : <Tag color="geekblue">Cold</Tag>;
};
